import React from "react";

const Input = ({
    onChange,
    value,
    placeholder,
    name, 
    showSearchIcon,
    onKeyPress
}) => {
    return (
        <div className="input-fields-wrapper marginBt">
        {showSearchIcon && <i class="fa fa-search"></i>}
         <input
            onChange={(e) => onChange(e.target.name, e.target.value, e)}
            value={value}
            className="input-field"
            type="text"
            placeholder={placeholder}
            name={name}
            onKeyPress={(e)=>{( e?.target?.value) && onKeyPress(e)}}
        />
        </div>
    );
};

export default Input;
